// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"info_wrapper__s3G_C","formBody":"info_formBody__t7ncM"};